import { createContext, useContext } from 'react';
import { HolidayMode } from '@theme/palettes/getPalette';
import { HeaderFireworks } from './HeaderFireworks';
import { HeaderRain } from './HeaderRain';
import { StringLights } from './StringLights';
import { useActiveHoliday } from './useActiveHoliday';

/**
 * False inside a Layout `customHeader` (e.g. the quote page's header + tab bar): Layout hangs the string lights
 * from the bottom of the whole block instead, otherwise the tab bar would cover them.
 */
export const HeaderLightsContext = createContext(true);

/** Holiday decorations that live in the header. Render inside the header's positioned container. */
export const HolidayHeaderEffects = () => {
  const holiday = useActiveHoliday();
  const showLights = useContext(HeaderLightsContext);

  switch (holiday) {
    case HolidayMode.Christmas:
      return showLights ? <StringLights /> : null;
    case HolidayMode.NewYear:
      return <HeaderFireworks />;
    case HolidayMode.InsuranceAwareness:
      return <HeaderRain />;
    default:
      return null;
  }
};
